import { BOARDS_ID } from '@constants';

const MY_ISSUES_MAPPER = {
  id: { key: 'id', label: 'ID' },
  board: {
    key: 'board',
    label: 'BOARD',
  },
  ticketId: { key: 'ticketId', label: 'TICKET ID' },
  status: {
    key: 'status',
    label: 'STATUS',
  },
  reason: { key: 'reason', label: 'REASON' },
  skuId: { key: 'skuId', label: 'SKU ID' },
  carId: { key: 'carId', label: 'CAR ID' },
  carInternalId: { key: 'carInternalId', label: 'CAR ID' },
  userId: { key: 'userId', label: 'USER ID' },
  pipedriveId: { key: 'pipedriveId', label: 'PIPEDRIVE ID' },
  pipedriveUrl: { key: 'pipedriveUrl', label: 'PIPEDRIVE URL' },
  subId: { key: 'subId', label: 'SUB ID' },
  bookingId: { key: 'bookingId', label: 'BOOKING ID' },
  plate: { key: 'plate', label: 'PLATE' },
  vehicle: { key: 'vehicle', label: 'VEHICLE' },
  username: { key: 'username', label: 'USERNAME' },
  email: { key: 'email', label: 'EMAIL' },
  updatedAt: { key: 'updatedAt', label: 'UPDATED AT' },
  createdAt: { key: 'createdAt', label: 'CREATED AT' },
  team: {
    key: 'team',
    label: 'TEAM',
  },
  dueDate: {
    key: 'dueDate',
    label: 'DUE DATE',
  },
  dealer: {
    key: 'dealer',
    label: 'DEALER',
  },
  financingProvider: {
    key: 'financingProvider',
    label: 'FINANCING PROVIDER',
  },
};

const INITIAL_MY_ISSUES_GRID_COLUMNS = Object.values(MY_ISSUES_MAPPER)
  .filter((item) => item.key !== 'id' && item.key !== 'carId')
  .map(({ key, label }) => ({
    value: false,
    label,
    key,
  }));

const BOARD_CODE_TO_KEY = Object.fromEntries(
  Object.entries(BOARDS_ID).map(([key, value]) => [value, key])
);

const MY_ISSUES_SORTING_FIELDS = {
  board: 'board_id',
  updatedAt: 'updated_at',
  createdAt: 'created_at',
};

const MY_ISSUES_FILTER_FIELDS = {
  board: 'board_id',
  status: 'status',
  reason: 'reason',
  pipedriveId: 'pipedrive_id',
};

const MY_ISSUES_PAGE_SIZE = 200;

const MY_ISSUES_DATE_FORMAT = 'dd/MM/yyyy';

const MY_ISSUES_DEFAULT_ORDER = 'desc';

const MY_ISSUES_DEFAULT_ORDER_BY = MY_ISSUES_SORTING_FIELDS.updatedAt;

export {
  BOARD_CODE_TO_KEY,
  MY_ISSUES_MAPPER,
  MY_ISSUES_PAGE_SIZE,
  MY_ISSUES_DATE_FORMAT,
  MY_ISSUES_DEFAULT_ORDER,
  MY_ISSUES_DEFAULT_ORDER_BY,
  INITIAL_MY_ISSUES_GRID_COLUMNS,
  MY_ISSUES_FILTER_FIELDS,
};

export const MY_TASKS_TABS = {
  boards: {
    label: 'Boards',
    key: 'boards',
  },
  mailbox: {
    label: 'Mailbox',
    key: 'mailbox',
  },
};
